import React from 'react'
import { IconButton, Grid, Tooltip } from '@mui/material'
import { ArrowForwardIos } from '@mui/icons-material'
import { useLang } from '~/hooks/useLang'
import useDispatchState from '~/features/Dispatch/stores/DispatchState'

interface NextNavegationButtonProps {
  readonly hasNext?: boolean
  readonly next?: VoidFunction
  readonly loadingDispatchForm?: boolean
  readonly id: number
}

export default function NextNavegationButton({
  hasNext,
  next,
  id,
}: NextNavegationButtonProps) {
  const { translate } = useLang()
  const isDisabled = !hasNext

  return (
    <Grid item>
      <Tooltip
        title={translate('Next')}
        componentsProps={{
          tooltip: { sx: { fontSize: '14px', padding: '6px 10px' } },
        }}
      >
        <span style={{ display: 'inline-block' }}>
          <IconButton
            disabled={isDisabled || !id}
            onClick={() => (next ? next() : false)}
          >
            <ArrowForwardIos />
          </IconButton>
        </span>
      </Tooltip>
    </Grid>
  )
}
